import { get_axios_instance, api_variables,errorHandler } from '@/apis/variables.js';

var axios_instance = get_axios_instance(api_variables.SERVICE_FBP_CLAIM_DATA);
var axios_instance_approve_claim = get_axios_instance(api_variables.SERVICE_FBP_APPROVE_CLAIM);

const _pk_name = "id";

const state = {
    data: [],
    isFetching: false,
    editMode: false,
    record:{}
};

const getters = {
    editMode:(state) =>{
      return state.editMode;
    },
    record: (state) => {
      return state.record;
    }
  }

const mutations = {
    set: (state, payload) => {
        state.data = payload;
        //console.log('fetched data', state.data)
    },

    setFetching: (state, payload) => {
        state.isFetching = payload;
    },

    updateEmployeeFBPClaimsById: (state, payload) => {
        //console.log(payload);
    },

    setEditMode: (state, payload) => {
        state.editMode = payload.editMode;
        state.record = payload.record;
      }

}

const actions = {
    async fetchAll({ commit }, payload) {
        //console.log("[state/payroll/fbp/fetchAll] Calling API...");
        try {
            commit("setFetching", true);
            let res = await axios_instance.get(`/`,{
                params: 
                    payload   
              });
            commit("setFetching", false);
            //console.log("[state/payroll/fbp/fetchAll] res: ", res);
            if (res.status == 200) {
                commit("set", payload);
            }
            return res;
        } catch(err) {
            //console.log(err);
        }
    },

    async update({ commit }, payload) {
        //console.log("[state/payroll/addnewclaim/update] Updating... Display payload", payload);
        try {
            commit("setSaving", true);
            let res = await axios_instance_approve_claim.put(``, payload);
            commit("setSaving", false);
            //console.log("[state/payroll/addnewclaim/update] res: ", res);
            if (res.status == 200) {
                commit("updateEmployeeFBPClaimsById", res.data);
            }
            return res;
        } catch(error) {
            throw errorHandler(error.response);
        }
    },

    async changeEditMode({ commit }, payload) {
        try {
            commit('setEditMode', payload);
        } catch (error) {
            // throw errorHandler(error.response);
            //console.log(error);
        }

    },
}

export default {
    namespaced: true,
    state,
    mutations,
    getters,
    actions
}